var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"active":_vm.isComponentModalActive,"full-screen":"","has-modal-card":""},on:{"update:active":function($event){_vm.isComponentModalActive=$event}}},[_c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[_c('editor',{attrs:{"api-key":"j42psxdlxzw597mdcz436lnnhg1u0rb8hfk5bwy8s6be2brr","init":{
                     height: 500,
                     menubar: false,
                     branding: false,
                     plugins: 'table',
                      toolbar: 'undo redo | formatselect |' +
                         'bold italic backcolor forecolor|checkbox' +
                          ' |table tabledelete | ' +
                         'tableprops tablerowprops tablecellprops | ' +
                         'tableinsertrowbefore tableinsertrowafter tabledeleterow |' +
                         ' tableinsertcolbefore tableinsertcolafter tabledeletecol'
                   }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "+_vm._s(_vm.content)+" ")],1),_c('footer',{staticClass:"modal-card-foot"},[_c('b-button',{attrs:{"type":"is-danger"},on:{"click":_vm.close}},[_vm._v("Close")])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }